import { render } from "./bannerDetail.vue?vue&type=template&id=833009a4&scoped=true"
import script from "./bannerDetail.vue?vue&type=script&lang=js"
export * from "./bannerDetail.vue?vue&type=script&lang=js"

import "./bannerDetail.vue?vue&type=style&index=0&id=833009a4&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-833009a4"]])

export default __exports__